import { render, staticRenderFns } from "./PreVideoRow.vue?vue&type=template&id=77c22c19&scoped=true"
var script = {}
import style0 from "./PreVideoRow.vue?vue&type=style&index=0&id=77c22c19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c22c19",
  null
  
)

export default component.exports